import {
  Component,
  EventEmitter,
  Inject,
  Input,
  OnInit,
  Optional,
  Output,
  ViewChild,
} from '@angular/core'
import {
  FormBuilder,
  FormControl,
  FormGroup,
  ReactiveFormsModule,
} from '@angular/forms'
import { SearchContactTypeModel } from '../../../core/models/contact-type.model'
import { MatButtonModule } from '@angular/material/button'
import {
  MatFormField,
  MatFormFieldModule,
} from '@angular/material/form-field'
import { MatInput, MatInputModule } from '@angular/material/input'
import { MatSelectModule } from '@angular/material/select'

import {
  MAT_DIALOG_DATA,
  MatDialog,
  MatDialogRef,
} from '@angular/material/dialog'

import { MatIconModule } from '@angular/material/icon'
import {
  MatExpansionPanel,
  MatExpansionPanelHeader,
  MatExpansionPanelTitle,
} from '@angular/material/expansion'
import {
  MatDatepicker,
  MatDatepickerModule,
} from '@angular/material/datepicker'
import { MatNativeDateModule, MatOption } from '@angular/material/core'
import { CommonModule } from '@angular/common'
import { MatTableModule } from '@angular/material/table'
import { MatPaginator } from '@angular/material/paginator'
import { DriverService } from '../../../core/services/driver/driver/driver.service'
import { MatProgressSpinner } from '@angular/material/progress-spinner'
import { LegalEntityClientService } from '../../../core/services/customer/legal-entity-client/legal-entity-client.service'
import {
  MatAutocompleteModule,
} from '@angular/material/autocomplete'
import { LocationService } from '../../../core/services/location/location/location.service'
import { Observable } from 'rxjs'
import { ServiceTypeService } from '../../../core/services/service/service-type/service-type.service'
import { VehicleTypeService } from '../../../core/services/vehicle/vehicle-type/vehicle-type.service'
import { DriverTypeService } from '../../../core/services/driver/driver-type/driver-type.service'
import { MatTooltip } from '@angular/material/tooltip'
import { VehicleService } from '../../../core/services/vehicle/vehicle/vehicle.service'
import { SubClientService } from '../../../core/services/customer/sub-client/sub-client.service'
import { ContractStatusService } from '../../../core/services/contract/contract-status/contract-status.service'
import { ModalEmployeeConsultantOperationalComponent } from '../../../features/employee/modal-employee-consultant-operational/modal-employee-consultant-operational.component'
import { ModalLegalEntityClientComponent } from '../../../features/customer/modal_client/modal-legal-entity-client/modal-legal-entity-client.component'

@Component({
  selector: 'search-logistics',
  imports: [
    CommonModule,
    ReactiveFormsModule,
    MatButtonModule,
    MatFormField,
    MatInput,
    MatSelectModule,
    MatIconModule,
    MatTableModule,
    MatExpansionPanel,
    MatExpansionPanelHeader,
    MatExpansionPanelTitle,
    MatDatepicker,
    MatFormFieldModule,
    MatInputModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatPaginator,
    MatSelectModule,
    MatOption,
    MatProgressSpinner,
    MatTooltip,
    MatAutocompleteModule,
  ],
  templateUrl: './search-logistics.component.html',
  styleUrl: './search-logistics.component.scss',
  standalone: true,
})
export class SearchLogisticsComponent implements OnInit {
  constructor(
    private driverService: DriverService,
    private formBuilder: FormBuilder,
    private legalEntityClientService: LegalEntityClientService,
    private locationService: LocationService,
    private serviceTypeService: ServiceTypeService,
    private vehicleTypeService: VehicleTypeService,
    private vehicleService: VehicleService,
    private driverTypeService: DriverTypeService,
    private subClientService: SubClientService,
    private contractStatusService: ContractStatusService,
    @Optional() private dialogRef: MatDialogRef<SearchLogisticsComponent>,
    @Optional() @Inject(MAT_DIALOG_DATA) public data: any,
    private dialog: MatDialog,
  ) {}

  subClientsList: any[] = []
  origemControl = new FormControl()
  destinoControl = new FormControl()
  filteredDrivers!: Observable<any[]>
  filteredOrigins!: Observable<any[]>
  filteredDestinations!: Observable<any[]>
  filteredVehicles!: Observable<any[]>

  clientSelected: any = {}

  form!: FormGroup
  itemsList: any[] = []
  loading = false
  listTypeDriver: any[] = []
  listDrivers: any[] = []
  listVehicles: any[] = []
  listTypeService: any[] = []
  listClient: any[] = []
  listLocation: any[] = []
  listConsultant: any[] = []
  listTypeVehicle: any[] = []
  listStatus: any[] = []
  employeeConsultantSelected: any = {}

  isExpanded: any = false

  @Output() responseSearch = new EventEmitter<any>()
  @ViewChild('panel') panel!: MatExpansionPanel

  @Output() response = new EventEmitter<any>()
  @Input() search: any
  editIndex: number | null = null
  editAgendaItem: any = null
  page = 1
  rows = 10
  numberRows = 0
  searchForm: SearchContactTypeModel = new SearchContactTypeModel()
  displayedColumns: string[] = ['date', 'startDate', 'endDate', 'action']
  columns: any[] = [
    { keyColumn: 'date', key: 'date', description: 'Data' },
    { keyColumn: 'startDate', key: 'startDate', description: 'Data Inicial' },
    { keyColumn: 'endDate', key: 'endDate', description: 'Data Final' },
    {
      keyColumn: 'action',
      key: { edit: true, delete: true },
      description: 'Ações',
    },
  ]

  ngOnInit(): void {
    this.createForm()
    this.listStatusContract()
    this.getListClient()
    // this.getListConsultant()
    this.getListLocations()
  }

  private _filter(value: string): any[] {
    const filterValue = value.toLowerCase()

    return this.listLocation.filter((opt) =>
      opt.descricao.toLowerCase().includes(filterValue),
    )
  }

  listAllDrivers() {
    this.driverService.listDriver().subscribe({
      next: (res) => {
        this.listDrivers = res.data
      },
      error: (err) => {
        console.error('Ocorreu um erro ao listar os motoristas', err)
      },
    })
  }

  addConsultanOperational() {
    const dialogRef = this.dialog.open(
      ModalEmployeeConsultantOperationalComponent,
      {
        enterAnimationDuration: '100ms',
        exitAnimationDuration: '100ms',
        maxWidth: '1200px',
        minWidth: '1200px',
        maxHeight: '650px',
        data: {
          item: this.employeeConsultantSelected,
          multiSelect: false,
        },
      },
    )
    dialogRef.componentInstance.responseSingle.subscribe((response: any) => {
      if (response) {
        if (response.remove == false) {
          this.employeeConsultantSelected = response.selection
          this.form
            .get('consultant')!
            .setValue(this.employeeConsultantSelected.nome)
        } else {
          this.clearItem(['consultant'])
        }
      }
    })
  }

  clearItem(items: string[]) {
    if (items.includes('consultant')) {
      this.employeeConsultantSelected = {}
      this.form.get('consultant')!.setValue('')
    }
  }

  listStatusContract() {
    this.contractStatusService.listContractStatus().subscribe({
      next: (res) => {
        this.listStatus = res.data
      },
      error: (err) => {
        console.error('Ocorreu um erro ao listar os motoristas', err)
      },
    })
  }

  listAllVehicle() {
    this.vehicleService.listVehicles().subscribe({
      next: (res: any) => {
        this.listVehicles = res.data
      },
      error: (err: any) => {
        console.error('Ocorreu um erro ao listar os motoristas', err)
      },
    })
  }

  // initOriginFilter(): void {
  //   this.filteredOrigins = this.form.get('origem')!.valueChanges.pipe(
  //     startWith(''),
  //     map((v) => {
  //       // Se for objeto, retorna a descrição
  //       if (v && typeof v === 'object' && v.descricao) {
  //         return v.descricao
  //       }
  //       if (v && typeof v === 'object' && v.estado) {
  //         return v.estado
  //       }
  //       // Se for string, retorna a string
  //       if (typeof v === 'string') return v
  //       return ''
  //     }),
  //     map((text) => (text ? removeAccents(text.toLowerCase()) : '')),
  //     map((searchText) => {
  //       return this.listLocation.filter((loc) => {
  //         const locDescription = loc?.descricao || ''
  //         const locState = loc?.estado || ''
  //         return (
  //           removeAccents(locDescription.toLowerCase()).includes(
  //             searchText,
  //           ) ||
  //           removeAccents(locState.toLowerCase()).includes(
  //             searchText,
  //           )

  //         )
  //       })
  //     }),
  //   )

  //   this.filteredDestinations = this.form.get('destino')!.valueChanges.pipe(
  //     startWith(''),
  //     map((v) => {
  //       if (v && typeof v === 'object' && v.descricao) {
  //         return v.descricao
  //       }
  //       if (v && typeof v === 'object' && v.estado) {
  //         return v.estado
  //       }
  //       if (typeof v === 'string') return v
  //       return ''
  //     }),
  //     map((text) => (text ? removeAccents(text.toLowerCase()) : '')),
  //     map((searchText) => {
  //       return this.listLocation.filter((loc) => {
  //         const locDescription = loc?.descricao || ''
  //         const locState = loc?.estado || ''
  //         return (
  //           removeAccents(locDescription.toLowerCase()).includes(
  //             searchText,
  //           ) ||
  //           removeAccents(locState.toLowerCase()).includes(
  //             searchText,
  //           )

  //         )
  //       })
  //     }),
  //   )

  //   this.filteredDrivers = this.form.get('driver')!.valueChanges.pipe(
  //     startWith(''),
  //     map((v) => {
  //       if (v && typeof v === 'object' && v.nome) {
  //         return v.nome
  //       }
  //       if (v && typeof v === 'object' && v.cpf) {
  //         return v.cpf
  //       }
  //       if (typeof v === 'string') return v
  //       return ''
  //     }),
  //     map((text) => (text ? removeAccents(text.toLowerCase()) : '')),
  //     map((searchText) => {
  //       return this.listDrivers.filter((loc) => {
  //         const driverName = loc?.nome || ''
  //         const driverCpf = loc?.cpf || ''
  //         return (
  //           removeAccents(driverName.toLowerCase()).includes(
  //             searchText,
  //           ) ||
  //           removeAccents(driverCpf.toLowerCase()).includes(
  //             searchText,
  //           )

  //         )
  //       })
  //     }),
  //   )
  //   this.filteredVehicles = this.form.get('vehicle')!.valueChanges.pipe(
  //     startWith(''),
  //     map((v) => {
  //       if (v && typeof v === 'object' && v.placa) {
  //         return v.placa
  //       }
  //       if (typeof v === 'string') return v
  //       return ''
  //     }),
  //     map((text) => (text ? removeAccents(text.toLowerCase()) : '')),
  //     map((searchText) => {
  //       return this.listVehicles.filter((loc) => {
  //         const vehiclePlate = loc?.placa || ''
  //         return (
  //           removeAccents(vehiclePlate.toLowerCase()).includes(
  //             searchText,
  //           )

  //         )
  //       })
  //     }),
  //   )
  // }

  createForm(): void {
    this.form = this.formBuilder.group({
      dateInitial: [''],
      dateEnd: [''],
      codeTg: [''],
      consultant: [''],
      cliente: [''],
      status: [null],
      event: [''],
    })
  }

  listSubClients() {
    this.subClientService.listSubClient().subscribe({
      next: (res: any) => {
        this.subClientsList = res.data
      },
      error: (err: any) => {
        console.error(err.message)
      },
    })
  }

  onDriverSelected(event: any) {}

  createModel() {
    const formValue = this.form.value

    const dateInitialStr = formValue.dateInitial
      ? new Date(formValue.dateInitial).toLocaleDateString('pt-BR')
      : ''
    const dateFinalStr = formValue.dateEnd
      ? new Date(formValue.dateEnd).toLocaleDateString('pt-BR')
      : ''

    return {
      dataInicio: dateInitialStr,
      dataFim: dateFinalStr,
      clienteId: this.clientSelected.id || null,
      consultorOperacionalId:
        this.employeeConsultantSelected.id === 0
          ? null
          : this.employeeConsultantSelected.id,
      statusId:
        this.form.get('status')?.value === 0
          ? null
          : this.form.get('status')?.value,
      codigoTg: this.form.get('codeTg')?.value || '',
      nomeEvento: this.form.get('event')?.value || '',
    }
  }

  searchFleet() {
    this.loading = true
    if (this.panel) {
      this.panel.close()
    }
    const item = this.createModel()
    this.responseSearch.emit(item)
  }

  getListTypeDriver() {
    this.driverTypeService.listDriverType().subscribe({
      next: (res) => {
        this.listTypeDriver = res.data
      },
      error: (err) => {
        console.error('Ocorreu um erro ao listar os motoristas', err)
      },
    })
  }

  addClient() {
    const dialogRef = this.dialog.open(ModalLegalEntityClientComponent, {
      enterAnimationDuration: '100ms',
      exitAnimationDuration: '100ms',
      maxWidth: '1200px',
      minWidth: '1200px',
      maxHeight: '650px',
      data: {
        item: this.clientSelected,
        multiSelect: false,
      },
    })
    dialogRef.componentInstance.responseSingle.subscribe((response) => {
      if (response) {
        if (response.remove == false) {
          if (response.selection.id != this.clientSelected.id) {
            this.clientSelected = response.selection
            this.form.get('cliente')!.setValue(this.clientSelected.nomeFantasia)
          }
        } else {
          this.clientSelected = {}
          this.form.get('cliente')!.setValue('')
        }
      }
    })
  }

  getListClient() {
    this.legalEntityClientService.listLegalEntityClient().subscribe({
      next: (res) => {
        this.listClient = res.data
      },
      error: (err) => {
        console.error('Ocorreu um erro ao listar os clientes', err)
      },
    })
  }

  // getListConsultant() {
  //   this.employeeService.listPagedEmployeeConsultantOperate().subscribe({
  //     next: (res) => {
  //       this.listConsultant = res.data
  //     },
  //     error: (err) => {
  //       console.error('Ocorreu um erro ao listar os clientes', err)
  //     }
  //   })
  // }

  getListLocations() {
    this.locationService.listLocation().subscribe({
      next: (res) => {
        this.listLocation = res.data
        // this.filteredOrigins = this.origemControl.valueChanges.pipe(
        //   startWith(''),
        //   map(value => this._filter(value))
        // )
        // this.filteredDestinations = this.destinoControl.valueChanges.pipe(
        //   startWith(''),
        //   map(value => this._filter(value))
        // )

        // this.initOriginFilter()
      },
    })
  }

  getListTypeService() {
    this.serviceTypeService.listServiceType().subscribe({
      next: (res) => {
        this.listTypeService = res.data
      },
    })
  }

  getListTypeVehicle() {
    this.vehicleTypeService.listVehicleType().subscribe({
      next: (res) => {
        this.listTypeVehicle = res.data
      },
    })
  }

  onOriginSelected(event: any) {}
  onDestinationSelected(event: any) {}

  editItem(item: any) {
    this.editIndex = this.itemsList.findIndex(
      (i) =>
        i.date === item.date &&
        i.startDate === item.startDate &&
        i.endDate === item.endDate,
    )
    this.editAgendaItem = { ...item }
    this.form.patchValue({
      date: item.date,
      startHours: item.startDate,
      endHours: item.endDate,
    })
  }

  deleteItem(item: any) {
    this.itemsList = this.itemsList.filter(
      (i) =>
        i.date !== item.date ||
        i.startDate !== item.startDate ||
        i.endDate !== item.endDate,
    )
  }

  saveEditAgendaItem() {
    if (this.editIndex !== null) {
      const formValue = this.form.value
      this.itemsList[this.editIndex] = {
        date: formValue.date
          ? new Date(formValue.date).toLocaleDateString('pt-BR')
          : '',
        startDate: formValue.startHours,
        endDate: formValue.endHours,
      }
      this.itemsList = [...this.itemsList]
      this.editIndex = null
      this.editAgendaItem = null

      this.form.patchValue({
        date: '',
        startHours: '',
        endHours: '',
      })
    }
  }

  resetForm(): void {
    if (this.panel) {
      this.panel.close()
    }

    this.employeeConsultantSelected = {}
    this.form.reset()

    const item = {
      dataInicio: '',
      dataFim: '',
      clienteId: null,
      statusId: null,
      codigoTg: '',
      nomeEvento: '',
      consultorOperacionalId: null,
    }

    this.responseSearch.emit(item)
  }

  cancel() {
    this.editIndex = null
    this.response.emit({ action: 'cancel' })
    this.resetForm()
  }
}
